import * as React from 'react';

interface Props {
  actionKey: string;
  onClick?: (action: string, e: React.MouseEvent<HTMLLIElement>) => void;
  onHover?: (action: string, e: React.MouseEvent<HTMLLIElement>) => void;
  selected?: boolean;
  className?: string;
  icon?: string;
}

const MenuItem: React.FC<Props> = props => {
  const { onClick, onHover, actionKey, selected, className, icon, children } =
    props;

  const didClick = React.useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      onClick?.(actionKey, e);
    },
    [onClick, actionKey]
  );

  const didHover = React.useCallback(
    (e: React.MouseEvent<HTMLLIElement>) => {
      onHover?.(actionKey, e);
    },
    [onHover, actionKey]
  );

  return (
    <li
      className={
        'menu-item' +
        (selected ? ' menu-item--selected' : '') +
        (className ? ' menu-item--' + className : '')
      }
      onClick={didClick}
      onMouseOver={didHover}
    >
      {icon && (
        <span
          className="menu-item-icon"
          style={{
            maskImage: `url(/media/icons/action-button/${icon}.svg)`,
            WebkitMaskImage: `url(/media/icons/action-button/${icon}.svg)`
          }}
        />
      )}
      {children}
    </li>
  );
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/MenuItem.tsx